import type { FunctionComponent } from "react";
import { t } from "i18next";
import * as S from "./styles";
import { Icon, Text } from "@smartsuite/react-ui/lib";
import { Colors } from "@smartsuite/types";

export const ActionError: FunctionComponent<{
  errorMessage: string;
}> = ({ errorMessage }) => {
  return (
    <S.Wrapper>
      <S.Content>
        <S.Title>
          <Icon name="important-lined" color={Colors.bRed} />
        </S.Title>
        <S.ErrorBox>
          <S.Text>
            <Text>{errorMessage} </Text>
          </S.Text>
          <Text>
            <a
              href="http://help.smartsuite.com/en/articles/7855608-google-integration-troubleshooting"
              target="_blank"
              className="link is-hover"
              rel="noopener"
            >
              {t("job-list.learn-how-to-fix-common-issues")}
            </a>
          </Text>
        </S.ErrorBox>
      </S.Content>
    </S.Wrapper>
  );
};
